// Press & media mentions. Newest first. `image` lives in /static/press/.
// type: article | podcast | video | radio | academic | community | launch
export const stats = [
  { value: '4M+', label: 'readers of my essays in 2025' },
  { value: '30+', label: 'outlets that covered my work' },
  { value: '8', label: 'YouTube creators, 4M+ combined subscribers' },
  { value: 'YC P26', label: 'PumpGTM, backed by Y Combinator', url: 'https://pumpgtm.com' }
]

export const featured = ['nyt-hardfork', 'inc-young-coders', 'futurism', 'register', 'marketplace-2026', 'sftrou-823']

// The essays that generated the coverage. Journalists want the primary source.
export const essays = [
  {
    id: 'illiterate-programmers',
    title: 'AI is Creating a Generation of Illiterate Programmers',
    date: 'Jan 2025',
    url: 'https://nmn.gl/blog/ai-illiterate-programmers',
    reach: '1.3M readers',
    summary: 'After twelve years of coding I noticed I had stopped being able to work without an AI assistant. The essay argues that AI tooling is quietly eroding the fundamentals of a whole generation of developers, and what to do about it.',
    coverage: 'NYT Hard Fork, Inc., Futurism, The Register, Marketplace Tech, Hacker News front page, ThePrimeagen, Tech With Tim'
  },
  {
    id: 'junior-devs',
    title: 'New Junior Developers Can’t Actually Code',
    date: 'Feb 2025',
    url: 'https://nmn.gl/blog/ai-and-learning',
    reach: 'Widely syndicated',
    summary: 'A follow-up written after dozens of conversations with new developers: the code works, but ask why and you get blank stares. On what struggling through problems used to teach and how to keep learning with AI in the loop.',
    coverage: 'ITPro, Diginomica, Inside Higher Ed, Developpez, ForrestKnight, Code Monkey'
  },
  {
    id: 'killing-b2b-saas',
    title: 'AI is Killing B2B SaaS',
    date: 'Feb 2026',
    url: 'https://nmn.gl/blog/ai-killing-b2b-saas',
    reach: 'Hacker News front page',
    summary: 'Why the most profitable business model on Earth is under threat when every customer believes they can vibe-code something better, what the market is already pricing in, and which SaaS companies survive.',
    coverage: 'Startups For the Rest of Us, TechPlanet, Inc42, Hacker News'
  }
]

// Short quotes cleared for use with attribution to Namanyay Goel.
export const quotes = [
  { text: 'We’re trading deep understanding for quick fixes, and while it feels great in the moment, we’re going to pay for this later.', context: 'on junior developers and AI, quoted by ITPro' },
  { text: 'I hate the term vibe coding for what I do. It implies recklessness.', context: 'to Inc42, Feb 2026' },
  { text: 'How do you keep asking customers for renewal, when every customer feels they can get something better built with AI?', context: 'from “AI is Killing B2B SaaS”' }
]

export default [
  {
    id: 'solo-founders-podcast',
    outlet: 'Solo Founders Podcast',
    label: 'Solo Founders',
    title: 'Searching For A Co-Founder Is How You Get A Bad One — 4 VC-Backed Solo Founders',
    date: 'Aug 2026',
    type: 'podcast',
    url: 'https://podcasts.apple.com/us/podcast/searching-for-a-co-founder-is-how-you-get-a-bad-one/id1881721449?i=1000784403426',
    note: 'Guest, with Julian Weisser and three founders from the first Solo Founders cohort.'
  },
  {
    id: 'yc-pumpgtm',
    outlet: 'Y Combinator',
    label: 'Y Combinator',
    title: 'PumpGTM — find and engage buyers across LinkedIn, email and X',
    date: '2026',
    type: 'launch',
    url: 'https://www.ycombinator.com/companies/pumpgtm',
    note: 'Second product from Giga Next, Inc.; runs go-to-market for 10+ YC companies.'
  },
  {
    id: 'developpez-better-way',
    outlet: 'Developpez.com',
    label: 'Developpez.com',
    title: 'Il existe une meilleure façon de coder avec l\'IA',
    date: 'May 2026',
    type: 'article',
    url: 'https://programmation.developpez.com/actu/383271/Il-existe-une-meilleure-facon-de-coder-avec-l-IA-par-Namanyay-Goel/',
    note: 'French translation of “There\'s a Better Way to Code with AI” for the largest French-speaking developer community.'
  },
  {
    id: 'developpez-open-source',
    outlet: 'Developpez.com',
    label: 'Developpez.com',
    title: 'L\'IA signifie la mort de l\'open source',
    date: 'Apr 2026',
    type: 'article',
    url: 'https://intelligence-artificielle.developpez.com/actu/382713/L-IA-signifie-la-mort-de-l-open-source-par-Namanyay-Goel/',
    note: 'French translation of “AI Means the Death of Open Source”.'
  },
  {
    id: 'ivan-turkovic',
    outlet: 'Ivan Turkovic',
    title: 'AI-Native Developers and the Coming Gatekeeper Generation',
    date: 'Jul 2026',
    type: 'article',
    url: 'https://www.ivanturkovic.com/2026/07/07/ai-native-developers-gatekeeper-generation/',
    note: '“A post that traveled the whole industry because every engineering manager recognized it.”'
  },
  {
    id: 'yc-x',
    outlet: 'Y Combinator',
    title: 'Gigacatalyst launch — “Congrats on the launch, @namanyayg!”',
    date: 'May 2026',
    type: 'launch',
    url: 'https://x.com/ycombinator/status/2054962444607652196',
    note: 'Y Combinator announcing my first company; PumpGTM is the follow-up.'
  },
  {
    id: 'yc-launch',
    outlet: 'Launch YC',
    title: 'Gigacatalyst: customize your software to every user with AI',
    date: 'May 2026',
    type: 'launch',
    url: 'https://www.ycombinator.com/launches/QMD-gigacatalyst-customize-your-software-to-every-user-with-ai'
  },
  {
    id: 'sftrou-823',
    outlet: 'Startups For the Rest of Us',
    label: 'Startups For the Rest of Us',
    title: 'Ep. 823 — Hot Take Tuesday: Is AI Killing B2B SaaS?',
    date: 'Mar 2026',
    type: 'podcast',
    url: 'https://www.startupsfortherestofus.com/episodes/episode-823-hot-take-tuesday-is-a-i-killing-b2b-saas-chatgpt-ads-openclaw',
    note: 'Rob Walling and guests spend the opening segment on my essay “AI is Killing B2B SaaS”.'
  },
  {
    id: 'marketplace-2026',
    outlet: 'Marketplace (APM)',
    label: 'Marketplace',
    title: '“Vibe coding”: how sites like Moltbook can disrupt the AI industry',
    date: 'Mar 2026',
    type: 'radio',
    url: 'https://www.marketplace.org/story/2026/03/02/vibe-coding-how-sites-like-moltbook-can-disrupt-the-ai-industry'
  },
  {
    id: 'inc42-autopilot',
    outlet: 'Inc42',
    label: 'Inc42',
    title: 'Software Enters The Autopilot Era',
    date: 'Feb 2026',
    type: 'article',
    url: 'https://inc42.com/features/software-enters-the-autopilot-era/',
    note: '“I hate the term vibe coding for what I do. It implies recklessness.”'
  },
  {
    id: 'techplanet',
    outlet: 'TechPlanet',
    title: 'How AI is Disrupting the $200 Billion B2B SaaS Industry',
    date: 'Feb 2026',
    type: 'article',
    url: 'https://techplanet.today/post/how-ai-is-disrupting-the-200-billion-b2b-saas-industry'
  },
  {
    id: 'hn-b2b-saas',
    outlet: 'Hacker News',
    title: '“AI is Killing B2B SaaS” on the front page',
    date: 'Feb 2026',
    type: 'community',
    url: 'https://news.ycombinator.com/item?id=46888441'
  },
  {
    id: 'aim-vibe-finish',
    outlet: 'Analytics India Magazine',
    title: 'Vibe Coding Lets Anyone Start, But Few Know How to Finish',
    date: 'Jan 2026',
    type: 'article',
    url: 'https://analyticsindiamag.com/ai-features/vibe-coding-lets-anyone-start-but-few-know-how-to-finish/'
  },
  {
    id: 'aim-building-first',
    outlet: 'Analytics India Magazine',
    title: 'Vibe Coding is Shifting Teams to a Building-First Culture',
    date: 'Jan 2026',
    type: 'article',
    url: 'https://analyticsindiamag.com/ai-features/vibe-coding-is-shifting-teams-to-a-building-first-culture/'
  },
  {
    id: 'aim-print-dec-2025',
    outlet: 'AIM Print Edition',
    title: 'The Myth of the Self-Coding Agent',
    date: 'Dec 2025',
    type: 'article',
    url: 'https://analyticsindiamag.com/magazine/aim-print-december-2025/'
  },
  {
    id: 'slashgear',
    outlet: 'SlashGear · Yahoo News',
    title: 'AI Is Killing The Job Market For Young Coders, New Study Shows',
    date: 'Oct 2025',
    type: 'article',
    url: 'https://www.slashgear.com/2005612/ai-coding-programmer-job-market-stanford-study/'
  },
  {
    id: 'aim-agentic',
    outlet: 'Analytics India Magazine',
    title: 'Is Agentic Coding Just a Smart Intern Pretending to Know More?',
    date: 'Oct 2025',
    type: 'article',
    url: 'https://analyticsindiamag.com/ai-features/is-agentic-coding-just-a-smart-intern-pretending-to-know-more/',
    note: 'Interview. “Speed from AI, judgment from humans — that’s the balance.”'
  },
  {
    id: 'aim-problematic',
    outlet: 'Analytics India Magazine',
    title: 'Why Programmers Are Using Problematic AI Code?',
    date: 'May 2025',
    type: 'article',
    url: 'https://analyticsindiamag.com/ai-features/why-programmers-are-using-problematic-ai-code/'
  },
  {
    id: 'aim-to-code',
    outlet: 'Analytics India Magazine',
    title: 'To Code or Not to Code',
    date: 'Mar 2025',
    type: 'article',
    url: 'https://analyticsindiamag.com/global-tech/to-code-or-not-to-code/'
  },
  {
    id: 'yeswehack',
    outlet: 'YesWeHack',
    title: 'Junior devs “can’t actually code” — OffSec roundup for CISOs',
    date: 'Mar 2025',
    type: 'article',
    url: 'https://www.yeswehack.com/news/devs-ai-coding-risks-researchers-decry'
  },
  {
    id: 'insidehighered',
    outlet: 'Inside Higher Ed',
    title: 'To make profit, AI companies will have to take your job',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://www.insidehighered.com/opinion/blogs/just-visiting/2025/02/27/make-profit-ai-companies-will-have-take-your-job'
  },
  {
    id: 'marketplace-2025',
    outlet: 'Marketplace Tech (APM)',
    title: 'If AI writes code, is coding still crucial for kids to learn?',
    date: 'Feb 2025',
    type: 'radio',
    url: 'https://www.marketplace.org/episode/2025/02/26/if-ai-writes-code-is-coding-still-crucial-for-kids-to-learn'
  },
  {
    id: 'inc-young-coders',
    outlet: 'Inc.',
    label: 'Inc.',
    title: 'A New AI Worry: Many Young Coders No Longer Know How Their Code Really Works',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://www.inc.com/kit-eaton/a-new-ai-worry-many-young-coders-no-longer-know-how-their-code-really-works/91151569'
  },
  {
    id: 'futurism',
    outlet: 'Futurism',
    label: 'Futurism',
    title: 'Young Coders Are Using AI for Everything, Giving “Blank Stares” When Asked How Programs Actually Work',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://futurism.com/young-coders-ai-cant-program'
  },
  {
    id: 'enrique-dans',
    outlet: 'Enrique Dans · IE Business School',
    title: 'The AI paradox: efficiency vs. experience in software development',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://medium.com/enrique-dans/the-ai-paradox-efficiency-vs-experience-in-software-development-feb6123f1452'
  },
  {
    id: 'nyt-hardfork',
    outlet: 'The New York Times · Hard Fork',
    label: 'The New York Times',
    title: 'How “Based” Is Grok 3? + Vibecoding 101',
    date: 'Feb 2025',
    type: 'podcast',
    url: 'https://www.nytimes.com/2025/02/21/podcasts/hardfork-grok-robinhood.html',
    note: 'Kevin Roose and Casey Newton discuss my essay on AI and junior developers.'
  },
  {
    id: 'register',
    outlet: 'The Register',
    label: 'The Register',
    title: 'Hey programmers — is AI making us dumber?',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://www.theregister.com/2025/02/21/opinion_ai_dumber/'
  },
  {
    id: 'itpro',
    outlet: 'ITPro',
    title: '“We’re trading deep understanding for quick fixes”: junior developers and AI tools',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://www.itpro.com/software/development/junior-developer-ai-tools-coding-skills'
  },
  {
    id: 'diginomica',
    outlet: 'Diginomica',
    title: 'AI risk — as trust in generative AI grows, the Great Forgetting has begun',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://diginomica.com/ai-risk-trust-generative-ai-grows-great-forgetting-has-begun'
  },
  {
    id: 'developpez',
    outlet: 'Developpez.com',
    title: 'L’IA est en train de créer une génération de programmeurs illettrés',
    date: 'Feb 2025',
    type: 'article',
    url: 'https://programmation.developpez.com/actu/368940/L-IA-est-en-train-de-creer-une-generation-de-programmeurs-illettres-par-Namanyay/',
    note: 'French translation of my essay for the largest French-speaking developer community.'
  },
  {
    id: 'zdnet',
    outlet: 'ZDNet',
    title: 'Most developers use AI in their daily workflows — but they don’t trust it',
    date: '2025',
    type: 'article',
    url: 'https://www.zdnet.com/article/most-developers-use-ai-daily-in-their-workflows-but-they-dont-trust-it-study-finds/'
  },
  {
    id: 'india-today',
    outlet: 'India Today',
    title: '“They’re Like Smart Goldfish”: How This Developer’s AI is Taking On Tech Giants',
    date: 'Jan 2025',
    type: 'article',
    url: 'https://www.indiatoday.in/impact-feature/story/theyre-like-smart-goldfish-how-this-developers-ai-is-taking-on-tech-giants-2671788-2025-01-29'
  },
  {
    id: 'hn-illiterate',
    outlet: 'Hacker News',
    title: '“AI is Creating a Generation of Illiterate Programmers” on the front page',
    date: 'Jan 2025',
    type: 'community',
    url: 'https://news.ycombinator.com/item?id=42813345',
    note: '1.3M+ readers, 2,000+ upvotes on r/programming, eight YouTube breakdowns.'
  },
  {
    id: 'outlook-india',
    outlet: 'Outlook India',
    title: 'Tech Entrepreneur Tackles Delhi’s Air Crisis With Groundbreaking App',
    date: '2024',
    type: 'article',
    url: 'https://www.outlookindia.com/hub4business/tech-entrepreneur-tackles-delhis-air-crisis-with-groundbreaking-app'
  },
  {
    id: 'airgradient',
    outlet: 'AirGradient',
    title: 'Turning Air Quality Data Into Actionable Insights',
    date: '2024',
    type: 'article',
    url: 'https://www.airgradient.com/blog/turning-air-quality-data-into-actionable-insights/'
  },
  {
    id: 'bwdisrupt',
    outlet: 'BW Disrupt · BusinessWorld',
    title: 'BharatHacks, a Hackathon to Solve Problems for India',
    date: 'Jul 2017',
    type: 'article',
    url: 'http://bwdisrupt.businessworld.in/article/BharatHacks-a-Hackathon-to-Solve-Problems-for-India/27-07-2017-123013/'
  },
  {
    id: 'google-code-in',
    outlet: 'Google Open Source Blog',
    title: 'Google Code-in 2014 wrap-up — Grand Prize winner',
    date: 'Apr 2015',
    type: 'article',
    url: 'https://opensource.googleblog.com/2015/04/google-code-in-2014-wrap-up-with.html',
    note: 'One of 25 grand-prize winners worldwide, at 16. Google flew my family to Mountain View.'
  }
]

export const videos = [
  { id: 'primeagen', creator: 'ThePrimeagen', title: 'AI Is Making You An Illiterate Programmer', url: 'https://www.youtube.com/watch?v=cQNyYx2fZXw', subs: '700k+' },
  { id: 'techwithtim', creator: 'Tech With Tim', title: '“New Junior Developers Can’t Actually Code”', url: 'https://www.youtube.com/watch?v=mTJOpK100bQ', subs: '1M+' },
  { id: 'forrestknight', creator: 'ForrestKnight', title: 'New Junior Developers Can’t Actually Code', url: 'https://youtu.be/6Jji5HNMze0', subs: '700k+' },
  { id: 'codemonkey', creator: 'Code Monkey', title: 'AI is creating illiterate programmers! (you?)', url: 'https://youtube.com/watch?v=2H4ouL4bCUs', subs: '600k+' },
  { id: 'chaiaurcode', creator: 'Chai aur Code', title: 'New Junior Developers Can’t Actually Code', url: 'https://www.youtube.com/watch?v=BQTaBibVbo4', subs: '600k+' },
  { id: 'singhinusa', creator: 'Singh in USA', title: 'DeepSeek R1: Illiterate Programmers Need to Listen!!', url: 'https://youtu.be/l3bMo7oIQhU', subs: '1M+' },
  { id: 'donthedeveloper', creator: 'DonTheDeveloper', title: 'AI is Creating a Generation of Bad Software Engineers', url: 'https://www.youtube.com/watch?v=NYcqIAr6Rnw' },
  { id: 'solofounders', creator: 'Solo Founders Podcast (Julian Weisser)', title: 'Searching For A Co-Founder Is How You Get A Bad One', url: 'https://podcasts.apple.com/us/podcast/searching-for-a-co-founder-is-how-you-get-a-bad-one/id1881721449?i=1000784403426', guest: true },
  { id: 'bigthinking', creator: 'Big Thinking #20 (Zaid Al Kazemi)', title: 'Solving AI Hallucinations — Namanyay Goel', url: 'https://www.youtube.com/watch?v=oSrchZdmtCc', guest: true }
]



// WEBPACK FOOTER //
// ./src/components/Press/data.js